import { cometh4337Params } from '$services/cometh/getComethWallet';
import {
  encodePacked,
  encodeAbiParameters,
  numberToHex,
  concat,
  toHex,
  type Hex,
  type Address,
  pad,
} from 'viem';
import type { GetPaymasterStubDataParameters } from 'viem/account-abstraction';

export const forgeComethPaymasterStubData = async (parameters: GetPaymasterStubDataParameters) => {
  const { validUntil, validAfter } = getPaymasterConfig();
  const { paymasterPostOpGasLimit, paymasterVerificationGasLimit } = getPaymasterGasConfig();

  return {
    paymaster: cometh4337Params.paymasterParams.paymaster as Address,
    paymasterData: encodePacked(
      ['bytes', 'bytes'],
      [
        encodeAbiParameters([{ type: 'uint48' }, { type: 'uint48' }], [+validAfter, +validUntil]),
        cometh4337Params.paymasterParams.dummySignature as Hex,
      ],
    ),
    paymasterPostOpGasLimit: BigInt(paymasterPostOpGasLimit),
    paymasterVerificationGasLimit: BigInt(paymasterVerificationGasLimit),
    chainId: parameters.chainId,
  };
};

const getPaymasterConfig = () => {
  const validUntilNumber =
    Math.floor(Date.now() / 1000) + cometh4337Params.paymasterParams.validUntil;
  const validUntil = pad(numberToHex(validUntilNumber), { size: 4 });

  const paymasterVerifierParams = encodeAbiParameters(
    [{ type: 'uint48' }, { type: 'uint48' }],
    [+cometh4337Params.paymasterParams.validAfter, +validUntil],
  );

  return {
    paymasterData: concat([paymasterVerifierParams, `0x${'00'.repeat(65)}`]),
    validUntil,
    validAfter: cometh4337Params.paymasterParams.validAfter,
  };
};

const getPaymasterGasConfig = () => {
  return {
    //constants used by cometh to enable the bundler to simulate the user operation without reverting,
    paymasterVerificationGasLimit: toHex(BigInt(60_0000)) as Hex,
    paymasterPostOpGasLimit: toHex(BigInt(20_000)) as Hex,
  };
};
